import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL || "";

const EMPTY_VERSION = {
  version: "",
  label: "",
  track: "",
  released_at: "",
  notes: "",
  demo_mode: false,
};

export default function useSystemVersion() {
  const [versionInfo, setVersionInfo] = useState(EMPTY_VERSION);

  useEffect(() => {
    let cancelled = false;

    axios.get(`${API}/api/system/version`).then(({ data }) => {
      if (!cancelled) {
        setVersionInfo({ ...EMPTY_VERSION, ...(data || {}) });
      }
    }).catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  return versionInfo;
}
